export const fa = {
    "TRIGGER_LISTEN": "در حال گوش دادن به محرک‌ها",
    "ASSIST_EMPTY_MSG": "هوش مصنوعی در حال گوش دادن به گفتگوی شماست و آماده است تا به صورت خودکار هنگام فعال شدن کمک کند.",
    "MYBOT_TRIGGET_LISTEN": "در حال حاضر هیچ وظیفه فعال My Bot وجود ندارد",
    "MYBOT_EMTPY_MSG": "برای شروع یک وظیفه در My Bot، به زبانه جستجو بروید و گزینه \"اجرای با ورودی‌های نماینده\" را برای وظیفه مورد نظر انتخاب کنید.",
    "PROACTIVE_MODE": "حالت پیش‌گیرانه",
    "SETTINGS": "تنظیمات",
    "HELP_AND_SUPPORT": "کمک و پشتیبانی",
    "HELP": "کمک",
    "LANGUAGE": "زبان",
    "THEME": "تم",
    "AUTOMATIC": "خودکار",
    "DARK": "تیره",
    "LIGHT": "روشن",
    "THEME_DESC": "این از حالت پیش‌فرض سیستم شما استفاده خواهد کرد",
    "DOCUMENTATION": "مستندات",
    "DOC_DESC": "مقاله‌های مستندات مفصل ما را بررسی کنید.",
    "FAQ_U": "سؤالات متداول",
    "FAQ_DESC": "سؤالات متداول در مورد نماینده هوش مصنوعی را ببینید.",
    "KORE_ACADEMY": "اکادمی کر",
    "KORE_ACA_DESC": "با شرکت در دوره‌ها، درباره نماینده هوش مصنوعی بیشتر بیاموزید.",
    "SEARCH": "جستجو",
    "MY_BOT": "روبات من",
    "ASSIST": "کمک",
    "TRANSCRIPT": "ترانکریپت",
    "HISTORY": "تاریخچه",
    "TAP_SEARCH":"برای جستجو ضربه بزنید",
    "STARTOVER": "از نو شروع کنید",
    "RESTART_INPUTS": "از نو با ورودی‌های ثبت‌شده شروع کنید",
    "ASKCUSTOMER": "از مشتری بپرسید",
    "TELLCUSTOMER": "به مشتری بگویید",
    "WELCOME_MSG": "پیام خوشامد",
    "SEND": "ارسال",
    "SENT": "ارسال شد",
    "AWAITING": "در انتظار پاسخ | برای ادامه تایپ کنید",
    "OVERRIDE": "برای ادامه تایپ کنید",
    "OVERRIDE_FILE": "فایل را برای ادامه ضمیمه کنید",
    "ACCEPT_RESPONSE": "پاسخ پذیرفته شد",
    "AGENT_ENTERED": "نماینده وارد شد",
    "EXPECTED_FORMAT": "فرمت مورد انتظار",
    "INPUT_VALUES": "مقادیر ورودی",
    "RESTART": "از نو شروع کنید",
    "START_OVER": "از نو شروع کنید",
    "RESTART_CAPTURE": "از نو با ورودی‌های ثبت‌شده شروع کنید",
    "CANCEL": "لغو",
    "INTERRUPT_DIALOG": "وظیفه گفتگو قطع شده",
    "RUN": "اجرا",
    "RUN_AGENT": "با ورودی‌های نماینده اجرا کنید",
    "STEP": "مرحله",
    "DIALOG_TASK": "وظیفه گفتگو",
    "FAQ": "سؤالات متداول",
    "SNIPPET": "پاسخ‌ها",
    "ARTICLE": "مقالات",
    "FILE": "فایل‌ها",
    "SUGGESTED": "پیشنهادی",
    "ALL_DIALOG": "همه وظایف گفتگو",
    "DIALOG_TEXT": "گفتگو",
    "INTENT_IDENTIFIED": "بیان مشتری",
    "NOT_WHAT_LOOKING": "پیشنهاد اشتباه؟",
    "BOT": "ربات",
    "CUSTOMER": "مشتری",
    "YOU": "شما",
    "TERMINATE_CONV": "پایان وظیفه گفتگو",
    "TERMINATE_CONV_DESC": "آیا مطمئن هستید که می‌خواهید وظیفه گفتگو را پایان دهید؟ هوش مصنوعی دیگر نمی‌تواند پیشنهادات ارائه دهد.",
    "YES_TERMINATE": "بله، پایان",
    "NO_CANCEL": "نه، لغو",
    "OVERRIDE_CONTINUE": "ادامه با حالت جایگزینی",
    "SUMMARY_TEXT": "خلاصه",
    "SUBMIT": "ارسال",
    "INTERRUPT_OCCURED": "قطع شد",
    "IDENTIFIED_INTENT": "نیّت شناسایی‌شده",
    "INTERRUPT_DESC": "اجرای این کار باعث پایان وظیفه گفتگو جاری شما خواهد شد.",
    "ACCEPT_RUN": "پذیرفتن و اجرا",
    "RUN_LATER": "اجرای بعدی",
    "KNOW_MORE": "بیشتر بدانید",
    "MORE_TEXT": "بیشتر",
    "LESS_TEXT": "کمتر",
    "VIEW_MORE": "بیشتر ببینید",
    "VIEW_LESS": "کمتر ببینید",
    "SHOW_MORE_FAQ": "سؤالات متداول بیشتر نشان دهید",
    "SHOW_LESS_FAQ": "سؤالات متداول کمتر نشان دهید",
    "SHOW_MORE_ARTICLE": "مقالات بیشتری نشان دهید",
    "SHOW_LESS_ARTICLE": "مقالات کمتری نشان دهید",
    "SHOW_MORE_SNIPPET": "پاسخ‌های بیشتری نشان دهید",
    "SHOW_LESS_SNIPPET": "پاسخ‌های کمتری نشان دهید",
    "SHOW_MORE_FILES": "فایل‌های بیشتری نشان دهید",
    "SHOW_LESS_FILES": "فایل‌های کمتری نشان دهید",
    "VIEW_ALL_DIALOG": "همه گفتگوها را ببینید",
    "VIEW_FEW_DIALOG": "چند گفتگو را ببینید",
    "HELP_FULL": "مفید بود؟",
    "THANKYOU": "ممنون!",
    "EXPAND_MORE": "گسترش / بیشتر",
    "CLOSE_TEXT": "بستن",
    "STARTED": "شروع شد",
    "ENDED": "پایان یافت",
    "VIEW_FULL_ARTICLE": "مشاهده مقاله",
    "VIEW_FULL_FILE": "مشاهده فایل",
    "COPIED": "کپی شد",
    "SENTI_ANALY": "تحلیل احساس",
    "WRONG_SUGGESTION": "پیشنهاد اشتباه",
    "INCORRECT_INTENT": "نیّت نادرست",
    "ACCIDENTAL_CLICK": "کلیک تصادفی",
    "TIME_TAKING": "زمان‌بر",
    "OTHER": "دیگر",
    "PLAYBOOK_EMPTY_MSG": "یک نمایش‌نامه انتخاب کنید",
    "PLAYBOOK_EMPTY_DESC": "هوش مصنوعی نمی‌تواند نمایش‌نامه را بارگذاری کند زیرا تمام نمایش‌نامه‌های موجود پویا هستند. برای دسترسی به نمایش‌نامه، روی 'انتخاب نمایش‌نامه' کلیک کنید",
    "STAGE": "مرحله",
    "PROCEED_TO_CLOSE": "به بسته شدن ادامه دهید",
    "RECOMENDED_PLAYBOOK": "نمایش‌نامه پیشنهادی",
    "PRIMARY_SCRIPTS": "سناریوهای اصلی",
    "DYNAMIC_SCRIPTS": "سناریوهای پویا",
    "RESUME": "ادامه",
    "ENABLE_CLOSE": "برای فعال‌سازی مرحله بسته شدن، بر روی دکمه ادامه کلیک کنید",
    "LIST_VIEW": "نمای لیست",
    "TERMINATE": "پایان",
    "MINIMIZE": "کوچک‌سازی",
    "MAXIMIZE": "بزرگ‌نمایی",
    "NO_SEARCH_RESULT": "نتیجه‌ای برای جستجو پیدا نشد",
    "SENTIMENT_AWAITING": "در انتظار تحلیل احساس",
    "POSITIVE": "مثبت",
    "NEGATIVE": "منفی",
    "ASSOCIATED_WORK_NOTES": "یادداشت‌های کارهای قبلی",
    "AGENT_JOINED_CONV": "نماینده به گفت‌وگو پیوست",
    "AUTOSCROLL_ASSIST": "حرکت خودکار محتوا در تب پشتیبانی",
    "FILE_SIZE_MSG": "حجم فایل باید کمتر از 25 مگابایت باشد. لطفاً دوباره تلاش کنید.",
    "AUTO_SCROLL_TOOLTIP":"کنترل پیمایش خودکار زبانه کمک، ربات من و محتوای زبانه متن",
    "OVERRIDE_BTN": "جایگزینی",
    "FILE_NAME":"نام فایل",
    "PLAYBOOK": "کتاب بازی",
    "CHOOSE_FILE": "انتخاب فایل",
    "SUMMARY_ERROR_TEXT": "متأسفیم، اما مشکلی در تولید خلاصه برای این گفت‌وگو وجود دارد. لطفاً خلاصه خود را ایجاد کنید.",
    "ASK_A_QUESTION": "سوالی بپرسید",
    "COPY": "کپی",
    "TELL_US_MORE": "بیشتر به ما بگویید...",
    "TAB_TEXT":"هیچ برگه‌ای فعال نیست! لطفاً حداقل یک برگه را فعال کنید",
    "THANKS_FEEDBACK": "از بازخورد شما متشکرم",
    "SOMETHING_WRONG": "چیزی اشتباه است",
    "CLICK_ERROR_DETAILS": "برای مشاهده جزئیات خطا کلیک کنید",
    "NO_ACTIVE_PLAYBOOK": "هیچ کتاب راهنمای فعالی وجود ندارد",
    "REPHRASE_QUESTION": "آیا می‌توانید سوال خود را دوباره بیان کنید یا چیز دیگری بپرسید؟",
    "INTERNAL_INFO": "اطلاعات داخلی",
    "SOURCES": "منابع",
    "CONVERSATION_SUMMARY": "خلاصه مکالمه",
    "WAITING": "در حال انتظار",
    "WIDGET_DISABLED": "ویجت غیرفعال شده است",
    "AI_SETTINGS_DISABLED": "تنظیمات هوش مصنوعی غیرفعال شده است! لطفاً با مدیر هوش مصنوعی تماس بگیرید",
    "SERVER_CONNECTION_ERROR": "خطا در اتصال به سرور",
    "VIEW": "مشاهده",
    "ATTACHMENT_INPUT": "ورودی ضمیمه",
    "TYPE_SUMMARY": "خلاصه را بنویسید",
    "VIEW_FULL_ARTICLE_2": "مشاهده مقاله کامل",
    "VIEW_FULL_FILE_2": "مشاهده فایل کامل",
    "BY":"توسط",
    GENERATE_SUMMARY: "ایجاد خلاصه",
    PREV_SUMMARIES: "خلاصه‌های ایجاد شده قبلی",
    DIALOG_WORKFLOWS: "جریان کار گفتگوها",
    SHOW_ALL_DIALOG: "نمایش همه وظایف گفتگو",
    SHOW_ALL_DIALOGS: "نمایش همه گفتگوها",
    CUSTOM_TAB: "زبانه سفارشی",
    AGENT_INPUT: "ورودی نماینده",
    "CUSTOM_EMPTY_MSG" : "هیچ جریان کار فعالی وجود ندارد",
    "CUSTOM_TAB_DESC" : "برای شروع یک جریان کار، یکی از آن‌ها را از لیست زیرین صفحه اجرا کنید.",
    "SUBMIT_OVERALL_FEEDBACK" : "ارسال نظر عمومی",
    "FEEDBACK_POPUP_SUBTITLE" : "نظرات در مورد ویجت و ویژگی‌های آن",
    "FEEDBACK_SATISFIED" : "رضایتمند",
    "FEEDBACK_UNSATISFIED" : "رضایتمند نیست",
    "FEEDBACK_PROVIDE_REASONS" : "مشکلاتی که در ویجت وجود دارد را بیان کنید...",
    "FEEDBACK_TITLE" : "نظر",
    "AGENTIC_THINKING" : "در حال فکر کردن",
    "AGENTIC_AGENT_TITLE" : "نماینده",
    "AGENTIC_COPILOT_MODE_TITLE" : "حالت نماینده همکار",
    "AGENTIC_SENDING_MESSAGE" : "در حال ارسال...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot به طور فعال به مکالمه شما گوش می‌دهد و آماده است تا به طور خودکار کمک کند",
    "AGENTIC_SEARCH_RESULTS" : "نتایج نماینده"
}